







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
import { Spinner } from 'vue-image-spinner2';
import DatePicker from 'vue-monthly-picker';

@Component({
    name: 'box-score',
    data: function () {
        return {
            boxScorePage_: 1,
        };
    },
    components: {
        Spinner,
    },
    computed: {
        ...mapState('box-score', ['allBoxScore', 'allallBoxScoreLoading', 'boxScorePerPage', 'boxScorePage', 'boxScoreTotal']),
        ...mapState('box-score', {
            allCatalogs: (state: any) => {
                const allBoxScore = state.allBoxScore.map((box: any) => {
                    return {
                        ...box,
                    };
                });
                return _.orderBy(allBoxScore, 'id', 'asc');
            },
        }),
    },
})
export default class BoxScore extends Vue {
    public allMonths!: any;
    public allMonthsLoading!: any;
    public selected: any = null;
    public currentMonth: any;
    public daysMonth: string = '';

    public boxScorePage!: any;
    public boxScorePage_!: any;

    public boxScoreTotal = 12;
    public boxScorePerPage = 1;

    allInfo = [
        { información: 'Ventas digitales periodo actual ($)' },
        { información: 'Ventas digitales periodo anterior ($)' },
        { información: 'Ventas tradicionales periodo actual ($)' },
        { información: 'Ventas tradicionales periodo anterior ($)' },
        { información: 'Ventas totales acumuladas ($)' },
        { información: 'Ventas totales acumuladas petriodo anterior($)' },
        { información: 'Compras ($)' },
        { información: 'Costos operativos ($)' },
        { información: 'Productividad Total (%)' },
        { información: 'Empleados (No.)' },
        { información: 'Numero de ordenes realizadas' },
        { información: 'Productividad Total(PT) %' },
        { información: 'Productividad Laboral (PL)%' },
        { información: 'Variación en ventas (VV)%' },
        { información: 'Ventas tradicionales por vendedor (VE) ($)' },
        { información: 'Ventas por catalogo (VC) %' },
        { información: 'Ticket promedio (TP) ($)' },
        { información: 'Ordenes totales (OT) No.' },
        { información: 'Ordenes concluidas exitosamente (OE) %' },
        { información: 'Confiabilidad de inventarios (CI) %' },
        { información: 'Tiempo de ciclo productivo (PCT) (min)' },
        { información: 'Tiempo de respuesta a reclamos (TRR) (min)' },
        { información: 'Tiempo de respuesta a preguntas (TRP) (min)' },
        { información: 'Catalogo de publicaciones nuevas (NPD)' },
        { información: 'Catalogo de publicaciones totales (CT)' },
        { información: 'Publicaciones Activas vs Inactivas (IPI)' },
        { información: 'Nivel de capacidades y competencias del personal (NCC)' },
        { información: 'Nivel de madurez de la empresa (NME)' },
        { información: 'Nivel de madurez de los procesos (NMP)' },
    ];

    allMonthsHeaders = [
        { mes: 'ENERO', abv: 'ENE' },
        { mes: 'FEBRERO', abv: 'FEB' },
        { mes: 'MARZO', abv: 'MAR' },
        { mes: 'ABRIL', abv: 'ABR' },
        { mes: 'MAYO', abv: 'MAY' },
        { mes: 'JUNIO', abv: 'JUN' },
        { mes: 'JULIO', abv: 'JUL' },
        { mes: 'AGOSTO', abv: 'AGO' },
        { mes: 'SEPTIEMBRE', abv: 'SEP' },
        { mes: 'OCTUBRE', abv: 'OCT' },
        { mes: 'NOVIEMBRE', abv: 'NOV' },
        { mes: 'DICIEMBRE', abv: 'DIC' },
    ];

    allInfoeaders = [{ thClass: 'th', key: 'info', label: 'Información' }];

    years = [
        { value: 2021, text: '2021' },
        { value: 2022, text: '2022' },
        { value: 2023, text: '2023' },
    ];

    allDays = [];
    allDaysTotal = [
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
        '200.00',
    ];

    setUrlPage(page: any) {
        page = page - 1;
        for (let m = 0; m < this.allMonthsHeaders.length; m++) {
            if (m == page) {
                this.currentMonth = this.allMonthsHeaders[page].mes;
                this.daysMonth = this.allMonthsHeaders[page].abv;
                if (this.allDays.length > 0) {
                    this.allDays = [];
                }
                this.daysOfMonth(this.selected, m + 1, this.daysMonth);
            }
        }
    }

    onSelected(año: number) {
        this.boxScorePage_ = 1;
        if (this.allDays.length > 0) {
            this.allDays = [];
        }

        let date = new Date();
        let month = 0;
        let y = date.getFullYear(); //current year

        if (año == y) {
            month = date.getMonth(); //current month numeric
            this.boxScorePage_ = month + 1;
        }
        for (let m = 0; m < this.allMonthsHeaders.length; m++) {
            if (m == month) {
                this.currentMonth = this.allMonthsHeaders[m].mes;
                this.daysMonth = this.allMonthsHeaders[m].abv;
            }
        }
        this.daysOfMonth(año, month + 1, this.daysMonth);
    }

    daysOfMonth(año, mes, mesLe) {
        let diasMes = new Date(año, mes, 0).getDate();
        for (var dia = 1; dia <= diasMes; dia++) {
            this.allDays.push(`${dia}-${mesLe}-${año}`);
        }
    }

    mounted() {
        if (this.selected === null) {
            this.selected = new Date().getFullYear();
        }
        this.onSelected(this.selected);
    }
}
